import TypeIcon from "~/components/shared/TypeIcon";
import type { PokemonType } from "~/types/pokemon";

interface MoveProps {
  type: PokemonType;
  children: string;
  value: number;
}

const Move = ({ type, children, value }: MoveProps) => {
  return (
    <div className="flex items-center justify-between font-bold">
      <div className="flex items-center gap-2">
        <TypeIcon type={type} />
        <span className="font-bold">{children}</span>
      </div>
      <span className="font-bold">{value}</span>
    </div>
  );
};

export default Move;
